import { render, staticRenderFns } from "./photoParticular.vue?vue&type=template&id=07bacffa&scoped=true"
import script from "./photoParticular.vue?vue&type=script&lang=js"
export * from "./photoParticular.vue?vue&type=script&lang=js"
import style0 from "./photoParticular.vue?vue&type=style&index=0&id=07bacffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bacffa",
  null
  
)

export default component.exports